import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { UserId } from "src/app/interfaces";
import { LogClass } from "src/app/logger";
import { UserFacade } from "src/app/user/services/user.facade";

@LogClass({ source: "Substitute Admin edit" })
@Component({
    selector: "substitute-admin-edit",
    templateUrl: "./admin-edit.component.html",
    standalone: false
})
export class AdminEditComponent implements OnInit {
  public userId: Observable<UserId>;
  public userName: Observable<string>;

  constructor(private facade: UserFacade, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.userId = this.facade.getUserIdFromRoute(this.route);
  }
}
